import SVG from 'Components/SVG';
import { SVG_TYPE } from 'Shared/enums';

const sidebarChats = [
  'Znaki drogowe - szybka powtórka',
  'Parkowanie równoległe krok po kroku',
  'Egzamin praktyczny - częste błędy',
  'Teoria przed egzaminem - skrót',
];

function InstructorAIPage() {
  return (
    <div className="instructor-ai-page">
      <section className="instructor-ai-page__hero">
        <div className="dashboard__container instructor-ai-page__hero-inner">
          <h1 className="instructor-ai-page__title">Instruktor AI</h1>
        </div>
      </section>

      <div className="dashboard__content instructor-ai-page__content">
        <div className="dashboard__container instructor-ai-page__layout">
          <aside className="instructor-ai-page__sidebar" aria-label="Panel czatów">
            <button type="button" className="instructor-ai-page__sidebar-action instructor-ai-page__sidebar-action--active">
              <SVG type={SVG_TYPE.ROBOT} />
              <span>Nowy czat</span>
            </button>

            <button type="button" className="instructor-ai-page__sidebar-action">
              <SVG type={SVG_TYPE.SEARCH} />
              <span>Wyszukaj czaty</span>
            </button>

            <div className="instructor-ai-page__sidebar-section">
              <p className="instructor-ai-page__sidebar-label">Twoje czaty</p>
              <div className="instructor-ai-page__sidebar-list">
                {sidebarChats.map((chat) => (
                  <button key={chat} type="button" className="instructor-ai-page__sidebar-chat">
                    {chat}
                  </button>
                ))}
              </div>
            </div>
          </aside>

          <main className="instructor-ai-page__chat">
            <div className="instructor-ai-page__empty-state">
              <div className="instructor-ai-page__avatar" aria-hidden="true">
                <SVG type={SVG_TYPE.ROBOT} />
              </div>
              <p>Pomogę Ci przygotować się do egzaminu</p>
            </div>

            <section className="instructor-ai-page__mobile-conversation" aria-label="Przykładowa rozmowa">
              <div className="instructor-ai-page__menu-button" aria-hidden="true">
                <span />
                <span />
                <span />
              </div>

              <div className="instructor-ai-page__bubble instructor-ai-page__bubble--user">Wytłumacz mi parkowanie równoległe krok po kroku</div>

              <div className="instructor-ai-page__response">
                <p>
                  Parkowanie równoległe brzmi jak czarna magia... dopóki nie rozbijesz go na kilka prostych kroków. Zróbmy to tak, żebyś mogła to
                  odtworzyć za każdym razem, bez stresu.
                </p>
                <p>
                  <strong>Parkowanie równoległe - krok po kroku</strong>
                </p>
                <p>
                  1. Ustawienie auta
                  <br />
                  2. Cofanie + skręt w prawo
                  <br />
                  3. Wyrównanie i korekta
                </p>
              </div>
            </section>

            <div className="instructor-ai-page__composer">
              <button type="button" className="instructor-ai-page__composer-icon" aria-label="Dodaj plik">
                <SVG type={SVG_TYPE.SEND_FILE} />
              </button>
              <button type="button" className="instructor-ai-page__composer-input">
                Zadaj mi pytanie, a spróbuję Ci pomóc
              </button>
              <button
                type="button"
                className="instructor-ai-page__composer-icon instructor-ai-page__composer-icon--mic"
                aria-label="Nagraj wiadomość">
                🎤
              </button>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default InstructorAIPage;
